import React, {Component} from 'react'
import MediaQuery from 'react-responsive'
import {bindActionCreators} from 'redux'
import {requestFetchPageShell, setShouldCallLogin} from './header-actions'
import connect from 'react-redux/es/connect/connect'
import PropTypes from 'prop-types'
import DesktopHeader from './DesktopHeader'
import MobileHeader from './MobileHeader'
import {getLanguageFromUrl, getSectionFromUrl} from '../../helpers/util'
import './css/scss/header.scss'
import '../../common/scss/style.scss'
import '../../common/scss/bootstrap.scss'

class Header extends Component {
  constructor(props) {
    super(props)
    this.state = {
      language: getLanguageFromUrl(),
      section: getSectionFromUrl(),
      activeItemFirstLevelMenu: 0
    }
  }

  componentDidMount() {
    this.props.requestFetchPageShell(this.state.language);
  }

  componentWillReceiveProps(nextProps) {
    const {data} = nextProps.pageShell
      if (this.state.activeItemFirstLevelMenu === 0 && this.props.pageShell.data !== data) {
        const header = data.header;
        const consumer = header.consumer;
        const business = header.business;
        const about = header.about;

        this.setState({activeItemFirstLevelMenu: 1})
        switch (this.state.section) {
          case 'consumer':
            this.setState({activeItemFirstLevelMenu: consumer.id})
            break
          case 'business':
            this.setState({activeItemFirstLevelMenu: business.id})
            break
          case 'about-yettel':
            this.setState({activeItemFirstLevelMenu: about.id})
            break
          default:
            this.setState({activeItemFirstLevelMenu: consumer.id})
        }
      }
  }

  render() {
    const pageShell = this.props.pageShell
    return (
      pageShell.isFetching ? null :
        <div>
          <MediaQuery query='(min-width: 1250px)'>
              <DesktopHeader pageShell={pageShell} setShouldCallLogin={this.props.setShouldCallLogin} cookie={this.props.cookie} language={this.state.language} section={this.state.section} session={this.props.session}
                             activeItemFirstLevelMenu={this.state.activeItemFirstLevelMenu}/>
          </MediaQuery>
          <MediaQuery query='(max-width: 1249px)'>
            <MobileHeader pageShell={pageShell} setShouldCallLogin={this.props.setShouldCallLogin} cookie={this.props.cookie} language={this.state.language} section={this.state.section} session={this.props.session}
                          activeItemFirstLevelMenu={this.state.activeItemFirstLevelMenu} />
          </MediaQuery>
        </div>
    )
  }
}

Header.propTypes = {
  requestFetchPageShell: PropTypes.func.isRequired,
  setShouldCallLogin: PropTypes.func.isRequired,
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(Object.assign({}, {requestFetchPageShell, setShouldCallLogin}), dispatch)
}

const mapStateToProps = state => {
  return {
    pageShell: state.pageShell,
    cookie: state.cookie,
    session: state.session,
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Header)
